import useDistributionMarket from '@/hooks/useDistributionMarket';

import BENameFields from './BENameFields';
import BirthdateField from './BirthdateField';
import NLNameFields from './NLNameFields';

export default function NaturalPartyFields() {
  const market = useDistributionMarket();

  if (market === 'NL') return <NLNameFields />;

  return (
    <>
      <BENameFields />
      <BirthdateField />
    </>
  );
}
